import { useState } from "react";
import { stageCopy } from "@/data/content";
import { Tilt } from "./Tilt";

const stages = [["student", "Still studying"], ["fresh", "Fresh graduate / just started"], ["young", "Already working for a while"]];

export const StagePicker = () => {
  const [stage, setStage] = useState(null);
  return (
    <div className="stage-picker" data-testid="stage-picker">
      <div className="container">
        <div className="stage-row">
          <div className="stage-label">Where are you in the journey?</div>
          <div className="stage-tabs">
            {stages.map(([k, label]) => (
              <button key={k} className={`stage-tab${stage === k ? " active" : ""}`} onClick={() => setStage(k)} data-testid={`stage-tab-${k}`}>{label}</button>
            ))}
          </div>
        </div>
        <div className={`stage-message${stage ? " show" : ""}`} data-testid="stage-message">{stage ? stageCopy[stage] : ""}</div>
      </div>
    </div>
  );
};

const stories = [
  ["01 • AMBIGUITY", "“Take a look and propose something.”", "At work, instructions are not always step by step. Learning how to clarify, think and move forward is part of the transition."],
  ["02 • RELIABILITY", "People remember whether they can depend on you.", "Your GPA may help you get the opportunity. Reliability, communication and attitude influence what happens next."],
  ["03 • GROWTH", "Your first job is another kind of education.", "The new curriculum is feedback, initiative, judgment, teamwork, reputation, discipline and continuous improvement."],
  ["04 • RESPONSIBILITY", "Your first paycheck is also a life transition.", "You begin making independent decisions about what your income should support, today and later."],
];

export const Story = () => (
  <section className="cream-motion" data-rail="The Transition" data-testid="story-section">
    <div className="container story-grid">
      <div className="story-sticky reveal">
        <div className="eyebrow">The transition nobody really teaches you</div>
        <h2 style={{ marginTop: 10, color: "var(--green)" }}>School gave you a system.<br /><span className="gold">Working life asks you to build one.</span></h2>
        <p className="lead">Campus2Corp focuses on the practical lessons that often sit between textbook knowledge and real working life, communication, reliability, initiative, feedback, confidence, relationships, habits and money.</p>
      </div>
      <div>
        {stories.map(([k, h, p]) => (
          <Tilt max={5} className="story-card reveal" key={k}><small>{k}</small><h3>{h}</h3><p>{p}</p></Tilt>
        ))}
      </div>
    </div>
  </section>
);

export const Bridge = () => {
  const [v, setV] = useState(50);
  const knob = v <= 2 ? "C" : v >= 98 ? "W" : "↔";
  return (
    <section className="bridge-section" data-testid="bridge-section">
      <div className="container bridge-grid">
        <div className="reveal">
          <div className="eyebrow">Campus → Corporate</div>
          <h2 style={{ marginTop: 10, color: "var(--green)" }}>Drag the line. See what changes.</h2>
          <p className="lead">The shift is not only about getting a job. You move from clearer rules into greater independence, and that requires a different set of habits.</p>
          <div style={{ display: "grid", gap: 8, marginTop: 18 }}>
            <div><strong style={{ color: "var(--green)" }}>Campus:</strong> structured deadlines, clearer marking criteria, individual achievement.</div>
            <div><strong style={{ color: "var(--green)" }}>Corporate:</strong> ambiguity, collaboration, judgment, initiative, communication and trust.</div>
          </div>
        </div>
        <div className="before-after reveal">
          <div className="ba-layer ba-before">
            <div className="ba-copy ba-copy-left"><div className="eyebrow">CAMPUS</div><h2>The path is usually clearer.</h2><p>Study → submit → exam → grade.</p></div>
          </div>
          <div className="ba-layer ba-after" style={{ clipPath: `inset(0 0 0 ${v}%)` }}>
            <div className="ba-copy ba-copy-right"><div className="eyebrow">CORPORATE</div><h2>The path needs more judgment.</h2><p>Clarify → collaborate → decide → adapt → deliver.</p></div>
          </div>
          <div className="ba-edge-label ba-edge-left">100% Campus</div>
          <div className="ba-edge-label ba-edge-right">100% Corporate</div>
          <div className="ba-line" style={{ left: `${v}%` }} />
          <div className="ba-knob" style={{ left: `${v}%` }}>{knob}</div>
          <input aria-label="Drag between campus and corporate" className="ba-range" max="100" min="0" type="range" value={v} onChange={(e) => setV(Number(e.target.value))} data-testid="bridge-range" />
        </div>
      </div>
    </section>
  );
};
